// extracted by mini-css-extract-plugin
export default {"overlay":"customModal_overlay__oTOKv","main-container":"customModal_main-container__CtHZ8"};